import { render } from "./PageTransition.vue?vue&type=template&id=be8cb820"
import script from "./PageTransition.vue?vue&type=script&lang=js"
export * from "./PageTransition.vue?vue&type=script&lang=js"

import "./PageTransition.vue?vue&type=style&index=0&id=be8cb820&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__